import React, { useEffect, useRef } from "react"
import { graphql, useStaticQuery } from "gatsby"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
//Context
import { useHomeStateContext } from "./../../context/homeContext"
//Components
import Image from "gatsby-image"
import BackgroundImage from "gatsby-background-image"
//Helpers
import { linearFunction } from "./../../helpers/mathHelpers"
//Styled Components
import { SloganWrapper } from "../../styles/homeStyles"

gsap.registerPlugin(ScrollTrigger)

export default function Slogan({ sloganText }) {
  //Contexts
  const { toggle } = useHomeStateContext()
  //Refs
  const scrollImg = useRef(null)
  const scrollBg = useRef(null)

  const { pic, logo } = useStaticQuery(graphql`
    query {
      pic: allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativePath: { eq: "home/4.jpg" }
        }
      ) {
        edges {
          node {
            sharp: childImageSharp {
              fluid(maxWidth: 3000) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
      logo: allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativePath: { eq: "home/js.jpg" }
        }
      ) {
        edges {
          node {
            sharp: childImageSharp {
              fluid(maxWidth: 3000) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)

  const imgPic = pic.edges[0].node.sharp.fluid
  const logoJs = logo.edges[0].node.sharp.fluid

  const resetMarkers = _ => {
    scrollImg.current.refresh()
    scrollBg.current.refresh()
  }

  const updateScroll = ({ progress, trigger }, yLimit, rotLimit) => {
    const scroll = progress.toFixed(3)
    const rotate = linearFunction(scroll, [0, 1], [rotLimit, -2])
    const y = linearFunction(scroll, [0, 1], [yLimit, -yLimit])
    gsap.to(trigger, {
      duration: 0.65,
      rotate,
      y,
    })
  }

  useEffect(() => {
    scrollImg.current = ScrollTrigger.create({
      trigger: ".img-central-wrapper",
      start: "0% bottom",
      end: "100% top",
      // markers: true,
      onUpdate: self => updateScroll(self, 120, -6),
    })
    scrollBg.current = ScrollTrigger.create({
      trigger: ".logo-js",
      start: "0% bottom",
      end: "100% top",
      // markers: true,
      onUpdate: self => updateScroll(self, 180, -45),
    })

    window.addEventListener("resize", resetMarkers)

    return () => {
      window.removeEventListener("resize", resetMarkers)
      scrollImg.current.kill()
      scrollBg.current.kill()
    }
  }, [])
  return (
    <SloganWrapper toggle={toggle}>
      <div className="home-design-content">
        <h2 className="stroke">
          <p className="stroke-text1">{sloganText[0]}</p>
          <p className="stroke-text2">
            a<span>w</span>
            <span>w</span>
            <span>w</span>ards.
          </p>
        </h2>
        <div className="img-central-wrapper">
          <Image className="img-central" fluid={imgPic} objectFit="cover" />
        </div>
        <h2 className="fill">
          <p className="fill-text1">{sloganText[1]}</p>
          <p className="fill-text2"> {sloganText[2]}</p>
        </h2>
        <BackgroundImage
          Tag="div"
          className="logo-js"
          fluid={logoJs}
        ></BackgroundImage>
      </div>
    </SloganWrapper>
  )
}
